import { z } from "zod";

import { buildNamespace } from "@smart/itops-types-basic";

import { system } from "./base";

export const MatterNS = buildNamespace({
  system,
  entity: "Matter",
} as const);

export const MatterSchema = z.object({
  uri: MatterNS.schema,
  operationId: z.string(),

  id: z.string(),
  versionId: z.string(),
  number: z.string().optional().nullable(),
  title: z.string().optional().nullable(),
  matterTypeId: z.string(),
  description: z.string().optional().nullable(),
  status: z.string(),
  isLead: z.boolean(),
  openedDate: z.string().optional().nullable(),
  referralType: z.string().optional(),
  clientIds: z.array(z.string()),
  otherSideIds: z.array(z.string()),
  originatingStaffId: z.string().optional().nullable(),
  personResponsibleStaffId: z.string().optional().nullable(),
  personAssistingStaffId: z.string().optional().nullable(),

  lastUpdatedAsSec: z.number().optional(),
  deleted: z.boolean().optional(),
  deletedAtSec: z.number().optional(),
});
